import { Box, IconButton, styled } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { Plus } from '@sweep-io/sweep-design/dist/icons';
import { NodeToolbar, Position } from '@xyflow/react';

const widthHeightByPosition = {
  [Position.Right]: {
    width: '16px',
    height: '100px',
  },
  [Position.Left]: {
    width: '16px',
    height: '100px',
  },
  [Position.Top]: {
    width: '100px',
    height: '16px',
  },
  [Position.Bottom]: {
    width: '100px',
    height: '16px',
  },
};
const BlueCircleButton = styled('button')({
  width: '8px',
  height: '8px',
  minWidth: '10px',
  minHeight: '10px',
  padding: '0px',
  margin: '0px',
  backgroundColor: colors.blue[500],
  border: `1px solid white`,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DuplicatorToolbarButton = ({
  position,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: {
  position: Position;
  onMouseEnter?: (position: Position) => void;
  onMouseLeave?: (position: Position) => void;
  onClick?: (position: Position) => void;
}) => {
  return (
    <NodeToolbar position={position} align="center" isVisible={true} offset={4}>
      <Box
        sx={{
          ...widthHeightByPosition[position],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& > .plus-icon-button': {
            display: 'none',
          },
          '&:hover > .plus-icon-button': {
            display: 'flex',
          },
          '& > .blue-circle-button': {
            display: 'flex',
          },
          '&:hover > .blue-circle-button': {
            display: 'none',
          },
        }}
      >
        <BlueCircleButton className="blue-circle-button" />
        <IconButton
          className="plus-icon-button"
          size="small"
          onMouseEnter={() => onMouseEnter?.(position)}
          onMouseLeave={() => onMouseLeave?.(position)}
          onClick={() => onClick?.(position)}
          sx={{
            width: '16px',
            height: '16px',
            padding: '0px',
            minWidth: '16px',
            backgroundColor: colors.white,
            border: `1px solid ${colors.blue[500]}`,
            '&:hover': {
              backgroundColor: `${colors.blue[500]}`,
              border: `1px solid ${colors.blue[500]}`,
              '& svg': {
                '& path': {
                  stroke: 'white',
                },
              },
            },
          }}
        >
          <Plus variant="tiny" color={colors.blue[500]} />
        </IconButton>
      </Box>
    </NodeToolbar>
  );
};
